import dayjs, { Dayjs } from "dayjs";

export const calculateDateRange = (selected: string): { from: Dayjs | null, to: Dayjs | null } => {
  let from: Dayjs | null = null;
  let to: Dayjs | null = dayjs(); 

  switch (selected) {
    case "Today":
      from = dayjs().startOf("day");
      to = dayjs().endOf("day");
      break;
    case "Yesterday":
      from = dayjs().subtract(1, "day").startOf("day");
      to = dayjs().subtract(1, "day").endOf("day");
      break;
    case "This Week":
      from = dayjs().startOf("week");
      to = dayjs().endOf("day");
      break;
    case "This Month":
      from = dayjs().startOf("month");
      to = dayjs().endOf("day");
      break;
    case "Last Week":
      from = dayjs().subtract(1, "week").startOf("week").hour(0).minute(0).second(0);
      to = dayjs().subtract(1, "week").endOf("week").hour(23).minute(59).second(0);
      break;
    case "Last Month":
      from = dayjs().subtract(1, "month").startOf("month").hour(0).minute(0).second(0);
      to = dayjs().subtract(1, "month").endOf("month").hour(23).minute(59).second(0);
      break;
    default:
      break;
  }

  return { from, to };
};
